import { SortByFn } from "react-table";

import { RowData } from "../columns";

const getConnectorSortKey = (row: RowData) => {
  const primaryObject = row.primaryObject || "";
  let destinationSettings = "";
  if (row.config?.destinationSettings) {
    destinationSettings = JSON.stringify(row.config.destinationSettings);
  }
  return `${primaryObject}|${destinationSettings}`;
};

export const connectorColumnSortFn: SortByFn<RowData> = (rowA, rowB) => {
  // Cache sort keys for each row during this sort operation
  const sortKeyCache =
    (connectorColumnSortFn as any)._sortKeyCache || new WeakMap();
  (connectorColumnSortFn as any)._sortKeyCache = sortKeyCache;

  const getCachedKey = (row: any) => {
    if (!sortKeyCache.has(row)) {
      sortKeyCache.set(row, getConnectorSortKey(row.original));
    }
    return sortKeyCache.get(row);
  };

  const keyA = getCachedKey(rowA);
  const keyB = getCachedKey(rowB);
  return keyA.localeCompare(keyB);
};
